export enum RBACPermissionTypes {
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
  NEW = 'new',
  NOT_READ = 'not_read'
}

export enum RBACActions {
  FINANCIAL = 'financial',
  INVENTORY = 'inventory',
  SUGARCANE = 'sugarcane',
  ORGANIZATION = 'organization',
  PROPERTY = 'property',
  PANEL_METHODOLOGY = 'panel_methodology',
  ADMIN_DATA_MANAGEMENT = 'admin_data_management',
  TIMELINE = 'timeline',
  SATELLITE_IMAGERY = 'satellite_imagery',
  SCOUTING_TASK = 'scouting_task',
  SAMPLING_TASK = 'sampling_task',
  WORSENED_STATUS_BY_PROBLEM_ALERT = 'worsened_status_by_problem_alert',
  DELAYED_MONITORING_ALERT = 'delayed_monitoring_alert',
  WORSENED_STATUS_ALERT = 'worsened_status_alert',
  NEW_MONITORING_IN_PROPERTY_ALERT = 'new_monitoring_in_property_alert',
  REGIONAL_RISK = 'regional_risk',
  FIELDS = 'fields'
}

export enum RBACLevels {
  WORKSPACE = 'workspace',
  PROPERTY = 'property',
  SYSTEM = 'system',
  ORG = 'org',
  APP = 'app',
  USER = 'user'
}

export enum RBACQueryType {
  GET_ALL_ROLES_BY_USER = 'GET_ALL_ROLES_BY_USER',
  GET_WORKSPACE_OPERATIONS = 'GET_WORKSPACE_OPERATIONS'
}
